<div class="container-xl">
    <app-breadcrumb [crumbs]="crumbs"></app-breadcrumb>

    <mat-checkbox [formControl]="fcShowHistoric">Toon historie</mat-checkbox>
    <table class="table table-hover table-last-col table-add-row">
        <thead>
            <tr>
                <th>
                    Soort
                </th>
                <th>
                    Opmerking
                </th>
                <th>
                    Publieke opmerking
                </th>
                <th>
                    Medewerkers
                </th>
                <th>
                    Periode
                </th>
                <th width="110">
                    Tijden
                </th>
                <th>
                    Goedgekeurd
                </th>
                <th class="w-0">
                </th>
            </tr>
        </thead>
        <tbody>
            @for (leave of leaves(); track leave.id) {
                <tr
                    [routerLink]="['/',Routenames.leave,leave?.id]"
                    [class.current]="(leave.begindate | datetimeBefore : now) && !(leave.enddate | datetimeBefore : now)"
                    [class.past]="leave.enddate | datetimeBefore : now"
                    class="curpoint">
                    <td>
                        {{(leaveTypes() | byId : leave?.leave_type : 'key')?.name}}
                    </td>
                    <td>
                        {{leave.comment}}
                    </td>
                    <td>
                        {{leave.public_comment}}
                    </td>
                    @if (!leave.common) {
                        <td>
                            @for (user of leave.users; track user.id; let last = $last) {
                                {{user.name}}{{last ? '' : ', '}}
                            }
                        </td>
                    } @else if (leave.common) {
                        <td>
                            Bedrijfsbreed
                        </td>
                    }
                    <td>
                        @if ((leave.begindate | isOtherDate : leave.enddate)) {
                            @let beginYear = (leave.begindate | date :'yyyy');
                            @let endYear = (leave.enddate | date :'yyyy');
                            {{leave.begindate | date :(beginYear !== endYear ? 'EEE d MMM yyyy' : 'EEE d MMM')}} t/m {{leave.enddate | date :'EEE d MMM yyyy'}}
                        } @else {
                            {{leave.begindate | date :'EEE d MMM yyyy'}}
                        }
                    </td>
                    <td>
                        {{leave.begintime | slice : 0 : 5}} - {{leave.endtime | slice : 0 : 5}}
                    </td>
                    <td>
                        {{leave.approved_by | userName: users()}}
                        <small>{{leave.approved_at | codaltDate:'EEE d MMM'}}</small>
                    </td>
                    <td class="py-0">
                        <div class="d-flex justify-content-end">
                            @if ((Roles.Management | hasRole) && !leave.approved_by && !leave.approved_at) {
                                <button (click)="approve($event, leave)" color="warn" mat-icon-button>
                                    <mat-icon class="fas fa-check"></mat-icon>
                                </button>
                            }
                            @if ((Roles.Management | hasRole) || (now | datetimeBefore : leave.begindate)) {
                                <button (click)="delete($event, leave)" color="warn" mat-icon-button>
                                    <mat-icon class="fas fa-trash"></mat-icon>
                                </button>
                            }
                        </div>
                    </td>
                </tr>
            }
        </tbody>
    </table>
</div>
<div class="button-wrapper">
    <div class="container-xl">
        <div class="buttons">
            <button [routerLink]="['/', Routenames.leave, 'new']" class="btn btn-primary w-100">
                Verlof toevoegen
            </button>
        </div>
    </div>
</div>

